import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock(_component_Checkbox, {
    modelValue: $data.enabled,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.enabled) = $event)),
    class: "question-timer",
    "font-size": "1.2rem"
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode(" Auto continue")),
      ($data.enabled)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " after " + _toDisplayString($data.remaining) + " sec", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}